/**
 * @packageDocumentation
 * Constructs and animates the background layers.
 * Assumes bg texture is 1920x1080 and should behave like "cover" inside the bg renderer (1920x1080),
 * while the bg CANVAS is CSS-scaled as cover by the resizer.
 */
import * as PIXI from "pixi.js";
import { Assets } from "pixi.js";
import { StartAppResize } from "../resizer";

export class backgroundAnimations {
  private app_bg!: PIXI.Application;
  private bgSprite!: PIXI.Sprite;

  constructor(
    private app_width: number,
    private app_height: number,
    private resize_to_device: number
  ) {
    (async () => {
      this.app_bg = new PIXI.Application();
      await this.app_bg.init({
        width: this.app_width,
        height: this.app_height,
        backgroundAlpha: 0,
        resolution: 2,
      });

      document.body.appendChild(this.app_bg.canvas);

      StartAppResize({
        app: this.app_bg,
        app_width: this.app_width,
        app_height: this.app_height,
        resize_to_device: this.resize_to_device,
        transformOrigin_Y: 50,
        translate_Y: 50,
        app_top: 50,
        app_name: "app_bg",
      });
    })();
  }

  public formWideBg() {
    // IMPORTANT: only create ONE bg sprite
    this.bgSprite = new PIXI.Sprite(Assets.get("bg_game"));
    this.bgSprite.anchor.set(0.5, 0.5);
    this.app_bg.stage.addChild(this.bgSprite);

    this.layoutWideBg();

    // Keep it stable if renderer resizes (portrait/landscape switches)
    // Layout is cheap; do it only when screen dims changed.
    let lastW = -1;
    let lastH = -1;
    this.app_bg.ticker.add(() => {
      const w = this.app_bg.screen.width;
      const h = this.app_bg.screen.height;
      if (w !== lastW || h !== lastH) {
        lastW = w;
        lastH = h;
        this.layoutWideBg();
      }
    });
  }

  private layoutWideBg() {
    if (!this.bgSprite) return;

    const screenW = this.app_bg.screen.width;
    const screenH = this.app_bg.screen.height;

    const texW = this.bgSprite.texture.width;
    const texH = this.bgSprite.texture.height;

    // cover inside renderer (usually 1 for 1920x1080, but safe to compute)
    const scale = Math.max(screenW / texW, screenH / texH);

    this.bgSprite.scale.set(scale);
    this.bgSprite.position.set(screenW / 2, screenH / 2);
  }

  public formBgAnimations() {
    // keep empty for now
  }
}
